import * as Actions from '../../actions/quickCheckOut/type';

const initialState = {
  loading: false,
  itemLoading: false,
  checkoutLoading: false,
  createdItem: {},
  favouriteItem: {},
  inventoryItem: {},
  favouriteItems: [],
  quickCheckData: '',
  qckListloading: false,
  checkOutList: [],
  error: '',
};
export const quickCheckOutReducer = (state = initialState, action) => {
  switch (action.type) {
    // create items
    case Actions.CREATE_QUICKCHECKOUT_ITEM_REQUEST:
      return {
        ...state,
        itemLoading: true,
      };
    case Actions.CREATE_QUICKCHECKOUT_ITEM_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        createdItem: action?.payload?.data || {},
      };
    case Actions.CREATE_QUICKCHECKOUT_ITEM_FAIL:
      return {
        ...state,
        itemLoading: false,
        error: action.payload,
      };

    // delete quick checkout
    case Actions.DELETE_CHECKOUT_REQUEST:
      return {
        ...state,
        deleteQckLoading: true,
      };
    case Actions.DELETE_CHECKOUT_SUCCESS:
      return {
        ...state,
        deleteQckLoading: false,
        deletedQck: action?.payload?.data || {},
      };
    case Actions.DELETE_CHECKOUT_FAIL:
      return {
        ...state,
        deleteQckLoading: false,
        deleteQckError: action.payload,
      };

    // update quickCheckout list on delete qck
    case Actions.UPDATE_CHECKOUT_LIST_ON_DELETE:
      const qckId = action?.payload?.id;
      const filteredList = state?.checkOutList?.filter(
        (qck) => qck?.quickCheckoutId !== qckId,
      );
      return {
        ...state,
        checkOutList: filteredList,
      };

    // clear deleted checkout state
    case Actions.CLEAR_DELETED_CHECKOUT_STATE:
      return {
        ...state,
        deleteQckLoading: false,
        deletedQck: '',
        deleteQckError: '',
      };

    // add items to inventory
    case Actions.ADD_ITEMS_TO_INVENTORY_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.ADD_ITEMS_TO_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        inventoryItem: action?.payload?.data || {},
      };
    case Actions.ADD_ITEMS_TO_INVENTORY_FAIL:
      return {
        ...state,
        loading: false,
        addItemsToInvErr: action.payload,
      };

    // add items to inventory
    case Actions.UPDATE_DELETE_FAVOURITE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.UPDATE_DELETE_FAVOURITE_SUCCESS:
      return {
        ...state,
        loading: false,
        favouriteItem: action?.payload?.data || {},
      };
    case Actions.UPDATE_DELETE_FAVOURITE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // get favourite items
    case Actions.GET_FAVOURITE_ITEMS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.GET_FAVOURITE_ITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        favouriteItems: action?.payload?.data || [],
      };
    case Actions.GET_FAVOURITE_ITEMS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.UPDATE_FAVOURITE_STATE:
      let favourits = state.favouriteItems;
      // adding to favourit if isFavourite is true
      if (action?.update && action?.payload?.data?.isFavourite) {
        // checked to check the favourite from list
        favourits = [...favourits, { ...action?.payload?.data, checked: true }];
      } else if (action?.update && !action?.payload?.data?.isFavourite) {
        // removing from fav
        favourits = favourits?.filter(
          (fav) => fav?.id !== action?.payload?.data?.id,
        );
      }
      if (action?.remove) {
        // deleting
        favourits = favourits?.filter(
          (fav) => fav?.id !== action?.payload?.data?.id,
        );
      }

      return {
        ...state,
        favouriteItems: favourits || [],
      };

    // Creating Quick Checkout
    case Actions.CREATE_QUICK_CHECK_OUT_REQUEST:
      return {
        ...state,
        checkoutLoading: true,
      };
    case Actions.CREATE_QUICK_CHECK_OUT_SUCCESS:
      return {
        ...state,
        checkoutLoading: false,
        quickCheckData: action?.payload?.data || {},
      };
    case Actions.CREATE_QUICK_CHECK_OUT_FAIL:
      return {
        ...state,
        checkoutLoading: false,
        error: action.payload,
      };
    case Actions.CLEAR_CREATE_QUICK_CHECK_OUT_STATE:
      return {
        ...state,
        checkoutLoading: false,
        quickCheckData: '',
        error: '',
      };

    // get checkout list
    case Actions.GET_CHECKOUT_LIST_REQUEST:
      return {
        ...state,
        qckListloading: true,
      };
    case Actions.GET_CHECKOUT_LIST_SUCCESS:
      return {
        ...state,
        qckListloading: false,
        checkOutList: action?.payload?.data || [],
      };
    case Actions.GET_CHECKOUT_LIST_FAIL:
      return {
        ...state,
        qckListloading: false,
        error: action.payload,
      };

    case Actions.CLEAR_QUICK_CHECK_OUT_STATE:
      return {
        ...state,
        loading: false,
        itemLoading: false,
        checkoutLoading: false,
        qckListloading: false,
        error: null,
        quickCheckData: '',
        favouriteItem: {},
        createdItem: {},
        inventoryItem: {},
        addItemsToInvErr: '',
      };

    default:
      return state;
  }
};
